<h1>Dragon Ball Z</h1>
<hr />

<div class="row">
	<div class="col">
		<!-- <app-personajes [data]="personajes"></app-personajes> -->
		<app-personajes></app-personajes>
	</div>

	<div class="col">
		<!-- <app-agregar 
			[nuevo]="nuevo">
			(onNuevoPersonaje)="agregarNuevoPersonaje($event)"
		</app-agregar> -->
		<app-agregar [nuevo]="nuevo"> </app-agregar>
	</div>
</div>
